import React from "react";
import logger from "logger";
import Constants from "Utils/Constants";
import Header from "Common/Header";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { loadData } from "Accounts";
import DashboardCard from "./DashboardCard";

function Login(props) {
  const user = useSelector(({ rootScope }) => rootScope.user);
  const isAdmin = user.roles.isAdmin;
  return (
    <div>
      <Header />
      <div className="komform">
        <Grid container spacing={1}>
          <Grid item>
            <DashboardCard
              title={"Accounts"}
              desc={"Open your accounts."}
              onClick={() => {
                loadData(user, props.history);
              }}
            />
          </Grid>
          {isAdmin && (
            <Grid item>
              <DashboardCard
                title={"Admin"}
                desc={"Open administration."}
                onClick={() => {
                  props.history.push(Constants.admin);
                }}
              />
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
}

export default withRouter(Login);
